export const getPoldTrigger = ({
  incident,
  poldOptOut,
  forceAlcohol = false,
  forceBarNight = false,
} = {}) => {
  const resolvedIncident = incident || {};
  const resolvedOptOut =
    poldOptOut ?? resolvedIncident?.ori?.poldOptOut ?? false;

  const incidentDrugTypes = Array.isArray(resolvedIncident?.drugTypes)
    ? resolvedIncident.drugTypes
    : [];
  const pisDrugTypes = Array.isArray(resolvedIncident?.personIncidentSpecifics)
    ? resolvedIncident.personIncidentSpecifics.flatMap(
        pis => pis?.drugTypes || [],
      )
    : [];
  const drugTypes = [...incidentDrugTypes, ...pisDrugTypes].filter(
    (dt, index, self) => dt && self.findIndex(d => d?.id === dt?.id) === index,
  );

  const offenses =
    resolvedIncident?.incidentDetail?.incidentOffenses ||
    resolvedIncident?.incidentOffenses ||
    [];

  const hasAlcohol =
    forceAlcohol || drugTypes?.some(dt => dt?.name === "Alcohol");

  const hasAlcoholInvolved = resolvedIncident?.incidentDetail?.alcohol === true;

  const hasBarNight =
    forceBarNight ||
    offenses?.some(offense =>
      offense?.locationType?.name?.startsWith("Bar/Night"),
    );

  const poldInstance = resolvedIncident?.poldInstance || {};
  const hasPoldSelection =
    poldInstance?.hasPold === true || poldInstance?.hasPold === false;
  const hasPoldDetails = poldInstance?.hasPold
    ? !!(poldInstance?.business || poldInstance?.address)
    : true;
  const isPoldComplete = hasPoldSelection && hasPoldDetails;

  const showPold =
    !resolvedOptOut && (hasAlcohol || hasBarNight || hasAlcoholInvolved);
  const needsPoldWarning = showPold && !isPoldComplete;

  return {
    showPold,
    needsPoldWarning,
    hasAlcohol,
    hasBarNight,
    isPoldComplete,
    poldOptOut: resolvedOptOut,
  };
};
